

















































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations, FormModes } from '@/ts/store/Constants';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import VariantMediaData from '@/ts/VariantMediaData';

@Component({
    computed: {
        ...mapGetters({
            formVisible: 'Viewport/isEditFormVisible',
        }),
    },
})
export default class EditVariantForm extends Mixins(InputFieldMethods) {
    @Prop() public formMode: string;

    constructor() {
        super();
    }

    get errorCollection() {
        return this.errors.any();
    }

    get isEditing() {
        return (this.formMode === FormModes.Edit);
    }

    get isCreating() {
        return (this.formMode === FormModes.Create);
    }

    get getProjectsData(): any {
        return this.$store.getters['Projects/allProjects'];
    }

    get getVariantsData(): any {
        return this.$store.getters['Variants/allVariants'];
    }

    get activeVariant(): any {
        return this.$store.getters['Variants/activeVariant'];
    }

    get getActiveVariantMedia(): any {
        return this.$store.getters['Variants/activeVariant'].media;
    }

    get variantProject(): number {
        return this.$store.getters['Variants/getVariantProject'];
    }

    set variantProject(value: number) {
        this.$store.commit(Mutations.UPDATE_VARIANT_PROJECT_ID, value);
        return;
    }

    get variantName(): string {
        return this.$store.getters['Variants/getVariantName'];
    }

    set variantName(value: string) {
        this.$store.commit(Mutations.UPDATE_VARIANT_NAME, value);
        return;
    }

    get variantArea(): string {
        return this.$store.getters['Variants/getVariantArea'];
    }

    set variantArea(value: string) {
        this.$store.commit(Mutations.UPDATE_VARIANT_AREA, value);
        return;
    }

    get variantRooms(): number {
        return this.$store.getters['Variants/getVariantRooms'];
    }

    set variantRooms(value: number) {
        this.$store.commit(Mutations.UPDATE_VARIANT_ROOMS, value);
        return;
    }

    get variantDescription(): string {
        return this.$store.getters['Variants/getVariantDescription'];
    }

    set variantDescription(value: string) {
        this.$store.commit(Mutations.UPDATE_VARIANT_DESCRIPTION, value);
        return;
    }

    public dataLoaded(): boolean {
        return (this.getVariantsData);
    }

    public selectFile(event: Event) {
        const element = (event.target as HTMLInputElement);

        if (element.files.length === 0) {
            return;
        }

        for (const file of element.files) {
            this.$store.commit(Mutations.ADD_VARIANT_SELECTED_MEDIA, {
                document: file,
                documentName: file.name,
            });
        }
    }

    public cancel() {
        if (this.isCreating) {
            this.$store.dispatch(Actions.HIDE_FORM);

            this.variantProject = null;
            this.variantName = '';
            this.variantArea = '';
            this.variantRooms = null;
            this.variantDescription = '';

            this.$nextTick(() => {
                this.errors.clear();
                this.$nextTick(() => {
                    this.$validator.reset();
                });
            });
        }

        if (this.isEditing) {
            this.$store.commit(Mutations.CANCEL_EDIT_VARIANT);
            this.$store.commit(Mutations.HIDE_EDIT_VARIANT_FORM);
        }
    }

    public edit() {
        this.$store.commit(Mutations.HIDE_EDIT_VARIANT_FORM);
        this.$store.dispatch(Actions.EDIT_VARIANT);
    }

    public previewMedia(item: VariantMediaData) {
        if (!this.activeVariant.persisted || !item.persisted) {
            return false;
        }

        this.$store.dispatch(Actions.FETCH_VARIANT_PREVIEW_MEDIA, {
            variantId: this.activeVariant.id,
            mediaId: item.id,
        });
    }

    public create() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                this.$store.dispatch(Actions.HIDE_FORM);
                this.$store.dispatch(Actions.POST_VARIANTS);
            }
        });
    }

    public removeDocument(itemId: number) {
        this.$store.commit(Mutations.REMOVE_DOCUMENT_FROM_ACTIVE_VARIANT, itemId);
    }

    public mounted() {
        if (this.activeVariant.persisted) {
            this.$store.dispatch(Actions.FETCH_VARIANT_MEDIA);
        }

        this.$store.dispatch(Actions.FETCH_PROJECTS);
    }
}
